const FEATURES = [
  {
    h: 'Knowledge graph as source of truth',
    p: 'Features, workflows, data model entities, UI components, ADRs, and validated edges live in a typed graph. The graph â€” not any single file â€” is the system of record.',
  },
  {
    h: 'Cognitive engine with five states',
    p: 'AWAKE, REM, NORMALIZING, NIGHTMARE, LUCID. Dream cycles generate hypotheses, the Truth Filter scores them, and the engine quietly compounds your understanding over time.',
  },
  {
    h: 'Speculation never mutates truth',
    p: 'Dreams live in their own graph until promoted. Latent candidates remain available for later promotion. Nothing speculative ever silently rewrites your facts.',
  },
  {
    h: 'Trust calibration for cognitive output',
    p: 'v13.0.0 - Cognitive Maintenance adds graph-health diagnostics, mandatory multi-hop semantic enrichment, confidence-aware neighborhood caching, targeted dream stabilization, PostgreSQL ownership discovery, and structured Explorer knowledge inspection.',
  },
  {
    h: 'Tensions: durable open questions',
    p: 'Conflicts, duplications, ownership gaps, and security signals get recorded as tensions. They sit there reminding you they exist until you resolve them. By design.',
  },
  {
    h: 'ADRs attached to entities',
    p: 'Architecture decisions are graph-aware: they attach to specific features, workflows, or data entities, can be queried, deprecated, and quoted back to you next year.',
  },
  {
    h: 'Datastore-as-Hub',
    p: 'First-class datastore entities. Live schema introspection through scan_database. The schema_grounding strategy aligns multiple repos that share a backend.',
  },
  {
    h: 'Multi-repo and monorepo native',
    p: 'A single instance can attach to multiple repositories. The engine builds links across repo boundaries that share workflows, APIs, databases, or ownership.',
  },
  {
    h: 'MCP-first',
    p: 'Every capability is exposed as an MCP tool. Use it from Claude Desktop, the DreamGraph VS Code Architect, or any MCP-aware client. No bespoke wiring required.',
  },
  {
    h: 'Bring your own LLM',
    p: 'Anthropic, OpenAI (including the Responses API and gpt-5.5 reasoning), Ollama, and LM Studio. Local-only setups are fully supported and recommended for sensitive code.',
  },
  {
    h: 'Local-first by default',
    p: 'Your code, your graph, your data. The daemon runs on your machine. Storage lives under ~/.dreamgraph. No telemetry, no required network calls.',
  },
  {
    h: 'VS Code Architect',
    p: 'Chat panel, live dashboard, Explorer, changed-files view, and connection management â€” all in the editor. Provider, model, and API key controlled per workspace.',
  },
  {
    h: 'Dream Explorer',
    p: 'Interactive graph rendering of features, workflows, data, ADRs, candidates, and tensions. Curated mutations let you promote, reject, edit, or attach right from the UI.',
  },
  {
    h: 'Shortest-path queries',
    p: 'Ask shortest_path how two entities are connected. BFS by default, Dijkstra over (1 âˆ’ confidence) when weighted, validated edges only unless you opt in to dreams. Great for impact analysis and architectural sanity checks.',
  },
  {
    h: 'Surgical markdown editing',
    p: 'patch_file, append_to_file, and edit_markdown_section let the Architect rewrite long docs without burning its edit budget on context lines. Section-aware, batched, idempotent.',
  },
];

export function Features() {
  return (
    <div className="page">
      <header className="page__header">
        <p className="eyebrow">Capabilities</p>
        <h1>Everything DreamGraph does, in one place.</h1>
        <p className="lede">
          DreamGraph is a governed architecture cognition layer: a daemon, an MCP server, a CLI, a VS Code extension, an Explorer, and a
          cognitive engine. The shortlist below is the part that matters when youâ€™re deciding
          whether to install it.
        </p>
      </header>

      <ul className="feature-grid">
        {FEATURES.map((f) => (
          <li key={f.h}>
            <h3>{f.h}</h3>
            <p>{f.p}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

